import React from "react";


const DeletePaymentMethodBtn = ({confirm, handleConfirmedCancelBtnClick, setConfirm, handleCancelBtnClick}) => {
    if (confirm) {
        return (
            <div style={{width: "275px"}} data-testid={'delete-payment-method-btn-div'}>
                <div>{i18n.payments.areYouSureRemovePaymentMethod}</div>

                <div className={'row'} style={{width: 'fit-content'}}>
                    <button type={"button"}
                            className={"button-pay red"}
                            style={{width: 'fit-content'}}
                            data-testid={'confirm-btn'}
                            onClick={handleConfirmedCancelBtnClick}>
                        {i18n.common.confirm}
                    </button>
                    <button type={"button"}
                            className={"button-pay gray"}
                            style={{width: 'fit-content'}}
                            data-testid={'cancel-btn'}
                            onClick={() => setConfirm(false)}>
                        {i18n.common.cancel}
                    </button>
                </div>
            </div>
        );
    }

    return (
        <button type={"button"}
                style={{
                    cursor: 'pointer',
                    backgroundColor: 'transparent',
                    border: '0',
                    marginLeft: '10px',
                    borderRadius: '2px',
                    height: 'fit-content'
                }}
                title="Delete"
                data-testid={'delete-payment-method-btn'}
                onClick={handleCancelBtnClick}>
            <img id="delete_btn_image" className="clear_button_small_svg"
                 src={'../images/svg/delete.svg'}
                 alt=""/>
        </button>
    );
}

export default DeletePaymentMethodBtn;